import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Numbers Component
// This component renders a SubjectTopics component for the Numbers subject
const Numbers = () => <SubjectTopics subjectId={1} title="Numbers" />;

export default Numbers; // Export the Numbers component
